import React, { FC } from 'react';
import classNames from 'classnames';
import { ASSETS_PATH } from '@root/app/react/const/variables';

interface ProductThumbnailYesorNoProps {
    imgSrc: string;
    name: string;
    clicked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    groupName: string;
}

export const ProductThumbnailYesorNo: FC<ProductThumbnailYesorNoProps> = (
    props,
) => {
    const {
        imgSrc, name, clicked, onChange, groupName,
    } = props;

    /* eslint-disable jsx-a11y/label-has-associated-control */
    return (
        <label
            className={classNames('product-thumbnail-yesorno', {
                selected: clicked,
            })}
        >
            <input
                type="radio"
                name={groupName}
                onChange={onChange}
                value={name}
                checked={clicked}
            />
            <div className="product-thumbnail-yesorno__svg">
                <img src={imgSrc} alt={name} />
            </div>
            <p className="product-thumbnail-yesorno__text1">{name}</p>
            <div className="product-thumbnail-yesorno__icon-selected">
                <img
                    src={`${ASSETS_PATH}/img/common/icon-selected.svg`}
                    alt="選択中"
                />
            </div>
        </label>
    );
    /* eslint-enable jsx-a11y/label-has-associated-control */
};
